import { render, staticRenderFns } from "./ReviewRequestDialog.vue?vue&type=template&id=5d49be90"
import script from "./ReviewRequestDialog.vue?vue&type=script&lang=js"
export * from "./ReviewRequestDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports